module.exports = __webpack_public_path__ + "static/img/equip3.1f5ebf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coreValues/equip3.png
// module id = ixql
// module chunks = 2